export const userDefinedHandlersAndOpts = [
  "handleAlignment",
  "defaultLinkedOligoMessage",
  "allowMultipleFeatureDirections",
  "getAdditionalEditAnnotationComps",
  "getAdditionalCreateOpts",
  "getLinkedOligoLink",
  "additionalTopRightToolbarButtons",
  "getCustomAutoAnnotateList",
  "allowPartsToOverlapSelf",
  "allowPrimerBasesToBeEdited",
  "truncateLabelsThatDoNotFit",
  "smartCircViewLabelRender",
  "onConfigureFeatureTypesClick",
  "allPartTags",
  "editTagsLink",
  "readOnly",
  "shouldAutosave",
  "hideSingleImport",
  "beforeAnnotationCreate",
  "disableSetReadOnly",
  "showReadOnly",
  "showCircularity",
  "onHiddenEnzymeAdd",
  "showMoleculeType",
  "showAvailability",
  "showCicularViewInternalLabels",
  "showGCContentByDefault",
  "GCDecimalDigits",
  "onlyShowLabelsThatDoNotFit",
  "fullscreenMode",
  "maxAnnotationsToDisplay",
  "onNew",
  "onImport",
  "onSave",
  "onSaveAs",
  "alwaysAllowSave",
  "generatePng",
  "onRename",
  "getVersionList",
  "getSequenceAtVersion",
  "onDuplicate",
  "onSelectionOrCaretChanged",
  "beforeSequenceInsertOrDelete",
  "enzymeManageOverride",
  "enzymeGroupsOverride",
  "additionalEnzymes",
  "onDelete",
  "onCopy",
  "autoAnnotateFeatures",
  "autoAnnotateParts",
  "autoAnnotatePrimers",
  "onCreateNewFromSubsequence",
  "onPreviewModeFullscreenClose",
  "onPaste",
  "menuFilter"
];
